export const pxToNumber = (pxValue: string): number => parseFloat(pxValue)
